import React, { useEffect, useState, useRef } from "react";
import "./HgsChat.scss";
import Icon from "../Icons/Icon";

function HgsChat(props) {
  const chatRef = useRef(null);
  const user = props.user || "User Name"; // Default user name if not provided
  const agent = props.agent || "Max AI coach"; // Default agent name if not provided
  const [isLoading, setIsLoading] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [inputMessage, setInputMessage] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [sessionId, setSessionId] = useState("user_1");
  const [inputType, setInputType] = useState("chat");
  const [outputType, setOutputType] = useState("chat");
  const [inputValue, setInputValue] = useState("");
  const [response, setResponse] = useState([]);
  const [outputValue, setOutputValue] = useState("");
  const [sessionTracking, setSessionTracking] = useState(false);
  const [conversation, setConversation] = useState([]);

  const flowId = "4f89845f-9583-467a-8d89-62442a70fcb4"; // Replace with your actual flow ID
  const baseURL = "http://localhost:7868"; // Replace with your Langflow base URL

  const addConversationItem = (text, date, who) => {
    const item = {
      date: date,
      text: text,
      who: who,
      type: who === "Max AI coach" ? "agent" : "customer",
    };
    setIsTyping(who === "Max AI coach" ? true : false);
    setIsLoading(who === "Max AI coach" ? false : true);
    if (text) setConversation((prev) => [...prev, item]);
  };

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop =
        chatRef.current.scrollHeight - chatRef.current.clientHeight;
    }
  }, []); // This runs once on mount; change dependencies to re-scroll on updates

  useEffect(() => {
    console.log("conversation", conversation);
  }, [conversation]);

  // useEffect(() => {
  //   //you can add deBouncing fnx with setTimeout() to not call api anytime user types
  //   const deBouncingFnx = setTimeout(() => {
  //     updateMessage();
  //     setIsLoading(true);
  //   }, 1000);

  //   // make sure you reset timer if using de-bouncer return () => clearTimeout(deBounceFnx)
  //   return () => clearTimeout(deBouncingFnx);
  // }, [inputValue]);

  const sendMessage = async () => {
    const body = {
      input_value: { inputValue },
      output_type: "chat",
      input_type: "chat",
      // Optional: Use session tracking if needed
      session_id: { user },
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        input_value: inputValue,
      }),
    };
    //add conversation item to the chat log
    addConversationItem(inputValue, new Date(), user);
    setInputValue("");

    try {
      const res = await fetch(`${baseURL}/api/v1/run/${flowId}`, options);
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(
          `HTTP error! status: ${res.status}, message: ${
            errorData.detail || "Unknown error"
          }`
        );
      }
      //setting data
      const data = await res.json();
      // Safely access message.text from the nested structure
      const messageText =
        data.outputs?.[0]?.outputs?.[0]?.results?.message?.text;

      if (messageText) {
        setResponseMessage(messageText);
      }
      setResponse(JSON.stringify(data, null, 2));
      setIsLoading(false);
      addConversationItem(messageText, new Date(), "Max AI coach");
    } catch (error) {
      setResponse(`Error: ${error.message}`);
      setIsLoading(false);
    }
  };

  return (
    <div className="hgs-chat">
      <div className="center">
        {/* <div className="contacts">
          <i className="fas fa-bars fa-2x"></i>
          <h2>Agents Online</h2>
          <div className="contact">
            <div className="pic ">
              <Avatar
                avatarStyle="Circle"
                topType="Hat"
                accessoriesType="Blank"
                facialHairType="Blank"
                clotheType="BlazerShirt"
                eyeType="Default"
                eyebrowType="Default"
                mouthType="Default"
                skinColor="Light"
              />
            </div>
            <div className="badge">14</div>
            <div className="name">Steve Shannon</div>
            <div className="message">Central America 🇺🇸</div>
          </div>
          <div className="contact">
            <div className="pic">
              <Avatar
                avatarStyle="Circle"
                topType="LongHairBob"
                accessoriesType="Kurt"
                facialHairType="Blank"
                clotheType="BlazerShirt"
                eyeType="Default"
                eyebrowType="Default"
                mouthType="Default"
                hatColor="Heather"
                skinColor="Light"
              />
            </div>
            <div className="name">Tony Ballonioni</div>
            <div className="message">North America 🇺🇸</div>
          </div>
          <div className="contact">
            <div className="pic">
              {" "}
              <Avatar
                avatarStyle="Circle"
                topType="WinterHat4"
                accessoriesType="Blank"
                facialHairType="Blank"
                clotheType="BlazerShirt"
                eyeType="Default"
                eyebrowType="Default"
                mouthType="Default"
                hatColor="Heather"
                skinColor="Light"
              />
            </div>
            <div className="badge">1</div>
            <div className="name">Bruce Pallice</div>
            <div className="message">South America 🇺🇸</div>
          </div>
          <div className="contact">
            <div className="pic">
              <Avatar
                avatarStyle="Circle"
                topType="WinterHat1"
                accessoriesType="Round"
                facialHairType="Blank"
                clotheType="BlazerShirt"
                eyeType="Default"
                eyebrowType="Default"
                mouthType="Default"
                hatColor="Heather"
                skinColor="Light"
              />
            </div>
            <div className="name">Thorior Yurgen </div>
            <div className="badge">3</div>
            <div className="message">Philippines</div>
          </div>
          <div className="contact">
            <div className="pic">
              <Avatar
                avatarStyle="Circle"
                topType="WinterHat1"
                accessoriesType="Round"
                facialHairType="Blank"
                clotheType="BlazerShirt"
                eyeType="Default"
                eyebrowType="Default"
                mouthType="Default"
                skinColor="Light"
              />
            </div>
            <div className="badge">2</div>
            <div className="name">Carol Shitzinger</div>
            <div className="message">Jamaica</div>
          </div>
        </div> */}
        <div className="chat" ref={chatRef}>
          <div className="contact bar">
            <div className="pic">
              <Icon
                iconClass={"big hgs-ideas text-primary"}
                name={"hgs-blue"}
              />
            </div>
            <div className="name">{agent}</div>
            <div className="seen">Today at {new Date().toDateString()}</div>
          </div>

          <div className="messages" id="chat">
            <div className="time">
              {conversation[0]
                ? new Date(conversation[0].date).toLocaleString()
                : null}
            </div>

            {Array.isArray(conversation) &&
              conversation.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`message ${item.type}`}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems:
                        item.type === "customer" ? "flex-end" : "flex-start",
                    }}
                  >
                    <i dangerouslySetInnerHTML={{ __html: item.text }} />
                    {/* {item.text} */}
                  </div>
                );
              })}
            {/* <div className="message customer">
              Can you help me process claim for short term disability? 👋
            </div>
            <div className="message agent">
              Sure thinkg, can you tell me your name and date of birth?{" "}
            </div>
            <div className="message customer">Rachelle Smitz</div>
            <div className="message customer">I am graphic designer</div>
            <div className="message agent">
              Yes I am graphic designer in StefaDesign.com
            </div> */}
            {isLoading && (
              <div className="message customer">
                <div className="typing typing-1"></div>
                <div className="typing typing-2"></div>
                <div className="typing typing-3"></div>
              </div>
            )}
            {isTyping && (
              <div className="message agent">
                <div className="typing typing-1"></div>
                <div className="typing typing-2"></div>
                <div className="typing typing-3"></div>
              </div>
            )}
          </div>

          <div className="input">
            <i className="fas fa-microphone"></i>
            <i className="fas fa-camera"></i>
            <input
              placeholder="Type your message here!"
              type="text"
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  sendMessage(); // call your function to send the message
                }
              }}
              onFocus={() => setIsTyping(true)}
              onBlur={() => setIsTyping(false)}
            />

            <i className="fa-regular fa-paper-plane" onClick={sendMessage}></i>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HgsChat;
